import React from 'react';
import VehicleReport from '../../../Report/vehicleReport';

export default function Vehicle() {
  return <VehicleReport />;
}
